import React, { Component } from 'react';
import {Modal,ModalBody,Button} from 'reactstrap';
import InfoMessage from '../../../../components/Message/InfoMessage/InfoMessage';
import Star from '../../../../assets/star.svg';
import EmptyStar from '../../../../assets/rating-star-grey.svg';
import './ToolDetails.css';

class RatingModal extends Component {
  state = { 
    userRating: 0,
    hoverStarIndex: 0,
    ratingOptions : [1, 2, 3, 4, 5]
   }

   cancelRating = () => {
     this.props.toggle();
     this.setState({userRating: 0});
   }
 
   submitRating = () => {
    this.props.onRateTool(this.state.userRating);
   }
   
  render() { 
    const {showModal, daniProps} = this.props;
    const {userRating, ratingOptions, hoverStarIndex} = this.state;
    return <div>
        <Modal isOpen={showModal} style={{top:'12px'}}>
          <ModalBody style={{ padding:'40px 0px' }}>
            <div className="row">
              <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 pick-office-modal-body-title" style={{lineHeight:'30px'}}>
                Add a Rating
              </div>
            </div>
            <div className="row mt10">
              <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 col-md-offset-right-1 archive-modal-msg">
                How would you rate this tool?
              </div>
            </div>
            <div className="row mt30">
              <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 col-md-offset-right-1">
              {ratingOptions.map((rating, index) => {
                if (hoverStarIndex > 0) {
                  if (rating <= hoverStarIndex) {
                    return <img className="cursor-pointer"
                      key={index}
                      style={{  width: '30px', height: '28.59px', marginLeft: index>0 ? '15px': '0px' }}
                      src={Star}
                      onMouseOut={() => this.setState({ hoverStarIndex: 0 })}
                      onClick={() => { this.setState({ userRating: index + 1 }) }}
                    />
                  }
                  else {
                    return <img className="cursor-pointer"
                      key={index}
                      style={{  width: '30px', height: '28.59px', marginLeft: index>0 ? '15px': '0px' }}
                      src={EmptyStar}
                      onMouseOver={() => this.setState({ hoverStarIndex: index + 1 })}
                      onMouseOut={() => this.setState({ hoverStarIndex: 0 })}
                      onClick={() => { this.setState({ userRating: index + 1 }) }}
                    />
                  }
                } else {
                  if (rating <= userRating)
                    return <img key={index}
                      onMouseOver={() => this.setState({ hoverStarIndex: index + 1 })}
                      className="cursor-pointer" style={{ width: '30px', height: '28.59px', marginLeft: index>0 ? '15px': '0px' }} src={Star} onClick={() => { this.setState({ userRating: index + 1 }) }} />
                  else
                    return <img key={index}
                      onMouseOver={() => this.setState({ hoverStarIndex: index + 1 })}
                      className="cursor-pointer" style={{  width: '30px', height: '28.59px', marginLeft: index>0 ? '15px': '0px' }} src={EmptyStar} onClick={() => { this.setState({ userRating: index + 1 }) }} />
                }
              })}
              </div>
            </div>
            {userRating > 0 && 
            <div className="row mt30">
              <div className="offset-md-1 col-sm-4 col-md-4">
                <Button onClick={this.submitRating} className="float-right continueBtn w100">
                  <span className="continueBtnTxt"><span className="mr10 flaticon-tick"></span>Submit</span>
                </Button>
              </div>
              <div className="col-sm-3 col-md-3">
                <Button className="float-left goBackBtn ml10 w100" onClick={this.cancelRating}>
                  <span className="goBackBtnTxt">Cancel</span>
                </Button>
              </div>
            </div>
            }
            {userRating === 0 && <div className="row mt30">
              <div className="col-sm-3 offset-md-1">
                <Button className="float-left goBackBtn w100" onClick={this.props.toggle}>
                  <span className="goBackBtnTxt">Done</span>
                </Button>
              </div>
            </div>
            }
          </ModalBody>
        </Modal>
      </div>;
  }
}
 
export default RatingModal;